import SPKToast from '$components/SPKToast/SPKToast';
import { useAppSelector } from '$hooks/use-app-selector.hook';
import { ReactComponent as Thunder } from '$icons/uncolored/thunder.svg';
import { useEditPositionEnhancedMutation } from '$store/modules/companies';
// import { InputText } from 'primereact/inputtext';
import { SelectButton } from 'primereact/selectbutton';
import { Controller, /*  useFieldArray, */ useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// enum CreateSmartInterviewMethods {
//   manual = 'manual',
//   simera = 'simera',
// }

const SPKFirstRoundInterview = () => {
  const [t] = useTranslation('global');
  const navigate = useNavigate();
  const {
    handleSubmit,
    control,
    formState: { errors },
    // watch,
  } = useForm({
    defaultValues: {
      enableSmartInterviews: null,
      // createSmartInterviewMethod: '',
      // employerQuestions: Array(4).fill({ questionText: '' }),
    },
  });
  const { employerLastCreatedPositionId } = useAppSelector(
    (state) => state.company
  );
  const [editPositionEnhanced] = useEditPositionEnhancedMutation();

  // const { fields: employerQuestionFields } = useFieldArray({
  //   control,
  //   name: 'employerQuestions',
  // });

  const enableSmartInterviewsOptions = [
    { label: t('common.yes'), value: true },
    { label: 'No', value: false },
  ];
  // const createSmartInterviewsMethodOptions = [
  //   {
  //     label: (
  //       <div className="flex flex-col">
  //         <span>{t('EmployerAddPosition.LetSimeraCreateQuestions')}</span>
  //         <span>({t('EmployerAddPosition.YouReviewBefore')})</span>
  //       </div>
  //     ),
  //     value: CreateSmartInterviewMethods.simera,
  //   },
  //   {
  //     label: t('EmployerAddPosition.IllWriteOwnQuestions'),
  //     value: CreateSmartInterviewMethods.manual,
  //   },
  // ];

  const onSuccessSubmitHandler = (data: any) => {
    editPositionEnhanced({
      positionId: employerLastCreatedPositionId as number,
      EnableSmartInterviews: data.enableSmartInterviews,
    }).then((resp) => {
      if ('data' in resp) {
        navigate('/employer-dashboard/positions', {
          state: {
            showSmartInterviewActivatedToast: data.enableSmartInterviews,
          },
        });
      }
    });
  };

  const onErrorSubmitHandler = () => {
    SPKToast('Please fill in all required fields before continuing.', {
      type: 'Error',
    });
  };

  // const enableSmartInterviewValue = watch('enableSmartInterviews');
  // const createSmartInterviewMethodValue = watch('createSmartInterviewMethod');

  return (
    <div className="text-center flex flex-col justify-center items-center">
      <Thunder className="fill-spk-scores-lowContrast my-10" />
      <h1 className="text-5xl font-extrabold mb-8">
        {t('EmployerAddPosition.WantSimeraConductFirstInterview')}
      </h1>
      <h3 className="mb-16">
        {t('EmployerAddPosition.SmartInterviewToolDescription')}
      </h3>
      <h3 className="text-left">
        {t('EmployerAddPosition.SmartInterviewToolExtendedDescription')}
      </h3>
      <form
        onSubmit={handleSubmit(onSuccessSubmitHandler, onErrorSubmitHandler)}
        className="w-full text-left flex flex-col mt-4 gap-4"
      >
        <div className="min-h-52">
          <label
            htmlFor="enableSmartInterviews"
            className="text-xs text-spk-mediumContrast"
          >
            {t('EmployerAddPosition.EnableSmartInterviews')}
          </label>
          <Controller
            control={control}
            name="enableSmartInterviews"
            rules={{
              validate: (value) =>
                value !== null || t('EmployerAddPosition.Errors.RequiredField'),
            }}
            render={({ field }) => (
              <SelectButton
                {...field}
                options={enableSmartInterviewsOptions}
                optionLabel="label"
                optionValue="value"
                className="w-full"
                allowEmpty={false}
                pt={{
                  button: {
                    className: `${
                      errors.enableSmartInterviews?.message &&
                      'border-spk-brightRed'
                    }`,
                  },
                }}
              />
            )}
          />
          {errors.enableSmartInterviews?.message && (
            <span className="text-xs text-spk-brightRed">
              *{errors.enableSmartInterviews?.message}
            </span>
          )}
        </div>

        {/* <div
          className={`${
            enableSmartInterviewValue ? 'flex flex-col' : 'hidden'
          }`}
        >
          <div>
            <label
              htmlFor="createSmartInterviewMethod"
              className="text-xs text-spk-mediumContrast"
            >
              {t('EmployerAddPosition.HowCreateInterviewQuestions')}
            </label>
            <Controller
              control={control}
              name="createSmartInterviewMethod"
              rules={{
                validate: (value) =>
                  !!value || t('EmployerAddPosition.Errors.RequiredField'),
              }}
              render={({ field }) => (
                <SelectButton
                  {...field}
                  options={createSmartInterviewsMethodOptions}
                  optionLabel="label"
                  optionValue="value"
                  className="w-full"
                  allowEmpty={false}
                  pt={{
                    button: {
                      className: `${
                        errors.createSmartInterviewMethod?.message &&
                        'border-spk-brightRed'
                      }`,
                    },
                  }}
                />
              )}
            />
          </div>
        </div> */}
        {/* <div
          className={`flex-col gap-2 ${
            enableSmartInterviewValue &&
            createSmartInterviewMethodValue ===
              CreateSmartInterviewMethods.manual
              ? 'flex'
              : 'hidden pointer-events-none hover:cursor-default'
          }`}
        >
          <span className="text-xs text-spk-mediumContrast">
            {t('EmployerAddPosition.ShareRecommendedQuestions')}
          </span>
          {employerQuestionFields.map((singleArrField, index) => (
            <Controller
              key={singleArrField.id}
              control={control}
              name={`employerQuestions.${index}.questionText`}
              render={({ field }) => (
                <InputText
                  {...field}
                  placeholder={t(
                    'EmployerAddPosition.Placeholders.EnterYourQuestion'
                  )}
                  className="w-full enabled:focus:!shadow-[0_0_0_0.2rem_#a6d5fa] focus:!border-[#2196f3] hover:!border-[#2196f3]"
                />
              )}
            />
          ))}
        </div> */}
        {/* <span
          className={`text-sm text-spk-mediumContrast ${
            (createSmartInterviewMethodValue !==
              CreateSmartInterviewMethods.manual ||
              !enableSmartInterviewValue) &&
            'mt-32'
          }`}
        >
          {t('EmployerAddPosition.DataAccessInfo')}
        </span> */}
        <button
          type="submit"
          className="rounded-full bg-employer-primary px-4 py-2 !text-spk-softBlue text-base font-semibold self-center"
        >
          {t('common.done')}
        </button>
      </form>
    </div>
  );
};

export default SPKFirstRoundInterview;
